
import HeightTween from 'vue-height-tween-transition'
import greenhouseMap from './mixins/greenhouse-data-map.coffee'
import DesktopFilters from './desktop-filters'
import MobileFilters from './mobile-filters'
import Listing from './job-listing.vue'

# Form initial value if default mode
defaultForm =
	location: ''
	jobType: ''
	query: ''
	familyOrDepartment: ''

# Form initial value if on early career mode
earlyCareerForm =
	location: ''
	jobType: 'Intern'
	query: 'New Grad'
	familyOrDepartment: ''

export default
	components: { HeightTween, DesktopFilters, MobileFilters, Listing }

	mixins: [greenhouseMap]

	props: block: Object

	data: ->
			# The filtering behavior
			# The default option starts the component with no filters applied, and shows
			# results which matches all the filtering criteria at the same time.
			# Early career option starts the component with the job type filter set to
			# "Intern" and the title/description search set to "New Grad". Shows results
			# that match the all the dropdown values at the same time OR match the title/description search input value.
			# PS: If this field is set to "Early Career" but there are no positions
			# that match the initial filtering values, the component will fallback to its default behavior.
			filterBehavior: @block.mode || "default"

			# Used to force focus state in a form select
			jobFamilyFocus: false

			# Used to force hover state in a form select
			jobFamilyHover: false

			# Data to be binded in the forms
			formBind: if @block.mode == 'earlyCareer' then earlyCareerForm else defaultForm

	computed:
		matchDropdownOrSearch: -> @filterBehavior == "earlyCareer"

		classes: -> [
			'has-filters': @hasFilters
			if @block.layout == 'default' then 'max-w-medium default-layout' else 'max-w-wide variation-one-layout'
		]

		desktopFilterClasses: -> [
			"desktop-only" if @block.layout == 'default'
		]

	methods:
	 	# handle job family focus state
		focusFamily: -> @jobFamilyFocus = true
		blurFamily: -> @jobFamilyFocus = false

		# handle job family hover state
		hoverFamily: ->	@jobFamilyHover = true
		leaveHoverFamily: -> @jobFamilyHover = false

		# Bind data on input event
		onInput: (value) ->
			@formBind.location = value.location
			@formBind.jobType = value.jobType
			@formBind.query = value.query
			@formBind.familyOrDepartment = value.familyOrDepartment

